export const ERR_SECURITY_ACCESS_DENIED = 'ERR_SECURITY_ACCESS_DENIED'
